<template>
  <div id="app">
    <transition :name="pageTransition">
      <router-view></router-view>
    </transition>
    <audio :src="url" loop id="alarm" hidden></audio>
  </div>
</template>

<script>
export default {
  name: "app",
  mixins: [global],
  components: {
    // HelloWorld
  },
  data() {
    return {
      isRouterAlive: true,
      pageTransition: "none",
      url: require("@/assets/media/alarm.mp3"),
    };
  },
  provide() {
    return {
      reload: this.reload,
      autoPageScroll: this.autoPageScroll,
      stopPageScroll: this.stopPageScroll,
    };
  },
  methods: {
    initAlarm() {
      this.$store.state.alarmAudio = document.getElementById("alarm");
      if (this.$store.state.alarmAudio) {
        window.removeEventListener("mousedown", this.initAlarm, false);
      } else {
        window.addEventListener("mousedown", this.initAlarm, false);
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    autoPageScroll() {
      let pageList = this.$store.state.pageScroll.scrollList;
      let i = 0;
      this.$store.state.interval = setInterval(() => {
        i = i % pageList.length;
        this.$router.push(pageList[i]);
        i++;
      }, this.pageScroll.interval);
    },
    stopPageScroll() {
      clearInterval(this.$store.state.interval);
    },
  },
  mounted() {
    this.initAlarm();
    if (this.isPageScroll) {
      this.pageTransition = "slide-left";
    } else {
      this.pageTransition = "none";
    }
    window.addEventListener(
      "message",
      (e) => {
        let { data } = e;
        if (data.name == "fromIframe") {
          this.$store.commit("SET_FROMIFRAME", true);
          let { lang } = data;
          let result = "zhHans";
          switch (lang) {
            case "zhcn":
              result = "zhHans";
              break;
            case "zhtw":
              result = "zhHant";
              break;
            case "jajp":
              result = "ja";
              break;
            case "enus":
              result = "en";
              break;
          }
          this.$store.commit("SET_LOCALE", result);
          this.$i18n.locale = this.locale;
        } else {
        }
      },
      false,
    );
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    pageScroll() {
      return this.$store.state.pageScroll;
    },
  },
  watch: {
    "pageScroll.scroll"(val, oldVal) {
      if (val) {
        this.pageTransition = "slide-left";
      } else {
        this.pageTransition = "none";
      }
    },
  },
};
</script>

<style lang="scss">
// @import "./assets/animate.css";
//-----------------------------------
//  font    face    思源黑体
//-----------------------------------
@font-face {
  font-family: "SiYuanHeiti";
  font-style: normal;
  font-weight: 400;
  // src: url("./assets/fonts/SourceHanSansCN-Regular.eot");
  // src: url("./assets/fonts/SourceHanSansCN-Regular.eot")
  //     format("embedded-opentype"),
  //   url("./assets/fonts/SourceHanSansCN-Regular.otf");
  src: url("./assets/fonts/SourceHanSansCN-Regular.woff2") format("woff2"),
    url("./assets/fonts/SourceHanSansCN-Regular.woff") format("woff"),
    url("./assets/fonts/SourceHanSansCN-Regular.ttf") format("truetype"),
    url("./assets/fonts/SourceHanSansCN-Regular.eot")
      format("embedded-opentype"),
    url("./assets/fonts/SourceHanSansCN-Regular.svg") format("svg");
}
@font-face {
  font-family: "SiYuanHeiti";
  font-style: normal;
  font-weight: 900;
  src: url("./assets/fonts/SourceHanSansCN-Heavy.woff2") format("woff2"),
    url("./assets/fonts/SourceHanSansCN-Heavy.woff") format("woff"),
    url("./assets/fonts/SourceHanSansCN-Heavy.ttf") format("truetype"),
    url("./assets/fonts/SourceHanSansCN-Heavy.eot") format("embedded-opentype"),
    url("./assets/fonts/SourceHanSansCN-Heavy.svg") format("svg");
}
@font-face {
  font-family: "AlibabaPuHuiTi";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/Alibaba-PuHuiTi-Regular.otf") format("OpenType");
}
@font-face {
  font-family: "AlibabaPuHuiTi";
  font-style: normal;
  font-weight: 500;
  src: url("./assets/fonts/Alibaba-PuHuiTi-Medium.otf") format("OpenType");
}
@font-face {
  font-family: "AlibabaPuHuiTi";
  font-style: normal;
  font-weight: 700;
  src: url("./assets/fonts/Alibaba-PuHuiTi-Bold.otf") format("OpenType");
}
@font-face {
  font-family: "JiangChengXieHei";
  font-style: normal;
  font-weight: 700;
  src: url("./assets/fonts/JiangChengXieHei-700W.ttf") format("truetype");
}
@font-face {
  font-family: "JiangChengXieHei";
  font-style: normal;
  font-weight: 900;
  src: url("./assets/fonts/JiangChengXieHei-900W.ttf") format("truetype");
}
@font-face {
  font-family: "DINCond-Bold";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/DINCond-Bold.otf") format("OpenType");
}
@font-face {
  font-family: "DINCond-BoldAlternate";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/DINCond-Regular.otf") format("OpenType");
}
@font-face {
  font-family: "DINCond-Medium";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/DINCond-Medium.otf") format("OpenType");
}
@font-face {
  font-family: "DINPro";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/DINPro-Regular.otf") format("OpenType");
}
@font-face {
  font-family: "DINPro";
  font-style: normal;
  font-weight: 500;
  src: url("./assets/fonts/DINPro-Medium.otf") format("OpenType");
}
@font-face {
  font-family: "YouSheBiaoTiHei";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/YouSheBiaoTiHei.ttf") format("truetype");
}
//-----------------------------------
//  main
//-----------------------------------
.clearfix {
  &:before,
  &:after {
    content: "";
    display: table;
  }
}
.ub {
  display: flex;
  &-v {
    flex-direction: column;
  }
}
.ub-flex {
  flex: 1;
  min-height: 10px;
  min-width: 10px;
}
.text-right {
  text-align: right;
}
* {
  box-sizing: border-box;
}

@each $var, $c in (primary, $--color-primary), (danger, $--color-danger),
  (success, $--color-success), (warning, $--color-warning),
  (info, $--color-info), (calm, $--color-calm), (em, $--color-black)
{
  .text-#{$var} {
    color: $c !important;
  }
}

html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  min-width: $--lg - 1;
  font-family: "SiYuanHeiti", "AlibabaPuHuiTi", "JiangChengXieHei",
    "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", "PingFang SC", "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  // font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  //   "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $--color-text-primary;
  // background: $--background-color-base ;
  background: $--background-color-base url("./assets/img/bg.jpg") no-repeat
    center;
  background-size: cover;
  font-size: $--font-size-base;
  line-height: 1.5;
  // overflow: hidden;
}
#app {
  // position: absolute;
  // top: 0;
  // bottom: 0;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
//----------------------------
//  page
//----------------------------
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 25px !important;
  &-flex {
    flex: 1;
    .panel-c {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .panel-table {
    flex: 1;
    margin-bottom: 0;
    .panel-c {
      display: flex;
      flex-direction: column;
    }
    .panel-table__table {
      flex: 1;
      min-height: 10px;
    }
  }
}
.toolbar {
  padding: 12px 14px 2px;
  // background: $--background-color-light;
  display: flex;
  &-form {
    flex: 1;
    $height: $--input-height;
    .el-form-item__label {
      height: $height;
      line-height: $height;
      display: none;
    }
    // .el-input__inner {
    //   height: $height;
    //   line-height: $height;
    //   font-family: inherit;
    // }
    .el-form-item__content {
      height: $height;
      line-height: $height;
    }
    // .el-input__icon {
    //   line-height: $height;
    // }
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input {
      width: 170px;
    }
  }
  &-btn {
    white-space: nowrap;
    margin-left: 1em;
    .el-button {
      font-size: $--font-size-small;
      i {
        font-size: $--font-size-base;
      }
    }
  }
  .el-button {
    padding: 9px 15px;
    // font-size: $--font-size-small;
    &.is-circle {
      padding: 9px;
    }
  }
}
.pagetool {
  display: flex;
  &-btn {
    flex: 1;
    text-align: right;
  }
}
.panel {
  &-table {
    .panel-c {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    &__table {
      //   flex: 1;
      //   min-height: 100px;
      //   position: relative;
      // display: flex;
      // flex-direction: row;
      padding: 6px 6px 0;
      .el-table {
        border-radius: ($--border-radius-large - 6) ($--border-radius-large - 6)
          0 0;
        // position: absolute;
        // flex: 1;
        // height: auto !important;
        // max-height: 100%;
      }
    }

    // }
  }
}

.colname {
  font-size: 1.25em;
  // padding-left: 0.5em;
  color: $--color-text-primary;
  &:before {
    content: "";
    display: inline-block;
    margin-right: 0.8em;
    width: 4px;
    height: 1em;
    border-radius: 10em;
    background: $--color-primary;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
}
//----------------------------
//  table
//----------------------------
.el-table {
  th {
  }
  td {
    padding: 7px 0;
    .cell {
      padding-top: 5px;
      padding-bottom: 5px;
    }
    a {
      cursor: pointer;
      .link-icon {
        color: $--color-primary;
        margin-right: 3px;
      }
      &:hover {
        color: $--color-primary;
        // text-decoration: underline;
      }
    }
  }
  .el-button.is-circle {
    font-size: 16px;
    padding: 6px;
    vertical-align: middle;
    svg {
      width: 16px;
      height: 16px;
      vertical-align: top;
    }
  }
}
.el-pagination {
  padding: 10px 20px;
  text-align: right;
  // display: flex;
  // align-items: center;
  @extend .clearfix;
  &__total {
    float: left;
  }
  &__sizes {
    float: left;
  }
  &__jump {
    // float: right;
  }
  span:not([class*="suffix"]),
  button {
    border-radius: 8px;
    height: 28px;
    line-height: 28px;
  }
  .btn-next,
  .btn-prev {
    padding: 0;
    // width: 30px;
    margin: 0 4px;
  }
  .el-select .el-input .el-input__inner {
    border-radius: 10em;
    // height: 35px;
    // line-height: 35px;
  }
  .el-input {
    vertical-align: middle;
    font-size: $--font-size-small;
  }
}
.el-pager {
  li {
    min-width: 30px;
    height: 28px;
    line-height: 28px;
    // border-radius: 10em;
    border-radius: 8px;
    margin: 0 4px;
    &.active {
      background: $--color-primary;
      color: #fff;
    }
  }
}
.table-icon {
  font-size: $--font-size-large;
  margin: -9px 0;
  svg {
    width: $--font-size-large;
    height: $--font-size-large;
  }
}
svg.table-icon {
  width: $--font-size-large;
  height: $--font-size-large;
}
.numTag {
  display: inline-block;
  line-height: 24px;
  padding: 0 1em;
  background: rgba($--color-primary, 0.1);
  border-radius: 10em;
  &--warning {
    background: rgba($--color-warning, 0.1);
  }
}

//数据参数行
.datacard {
  height: 4em;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 17px;
  h3 {
    font-size: 1em;
    font-weight: normal;
    border-bottom: 1px solid $--color-primary;
    line-height: 2.1;
    word-break: break-all;
    margin-top: -0.2em;
  }
  p {
    font-size: 1.2em;
    color: $--color-primary;
    cursor: pointer;
  }
}
@media screen and (max-width: $--lg) {
  .datacard {
    font-size: $--font-size-base;
    padding: 0 1em;
  }
}

//返回上一级 旁边的当前选择
.tagBar {
  margin-top: 8px;
  margin-bottom: 20px;
  // padding: 0 1em;
  color: $--color-text-secondary;
  .el-button {
    margin-right: 2em;
  }
  .el-tag {
    margin-right: 10px;
  }
}
@media screen and (max-width: $--lg) {
  .tagBar {
    margin-bottom: 10px;
  }
}
//----------------------------
//  svg icon
//----------------------------
/* recommended css code for vue-svgicon */
.svg-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  color: inherit;
  vertical-align: middle;
  fill: none;
  stroke: currentColor;
}

.svg-fill {
  fill: currentColor;
  stroke: none;
}

.svg-up {
  /* 默认 */
  transform: rotate(0deg);
}

.svg-right {
  transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}

.rotate {
  transform: rotate(180deg);
  transition: all 0.2s ease;
}
//----------------------------
//  dialog
//----------------------------
.dialog {
  &-msg {
    /deep/ .el-dialog__body {
      padding: 50px;
      line-height: 2;
    }
    p {
      margin-bottom: 10px;
    }
    em {
      color: $--color-primary;
    }
  }
  &-form {
    .el-form-item {
      margin-bottom: 15px;
    }
  }
}
.inputfra {
  background: $--background-color-base;
  border-radius: 20px;
  padding: 10px $--base-padding;
  overflow-y: auto;
  &--inset {
    border-radius: 10px;
    padding: 15px;
  }
  .panel {
    border: 0;
    margin-bottom: 15px;
    .panel--padding .panel-c {
      padding: 15px;
    }
  }
  .el-tree {
    background: none;
  }
}

.el-tree-node__content > label.el-checkbox {
  margin-right: 8px;
}

//----------------------------
//  动画  滚动
//----------------------------
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  // position: absolute;
  // &.pagefra {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // }
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}

//----------------------------
// tabs
//----------------------------
.tabs {
  &-tag {
    .el-radio-button__inner {
      border-radius: 10em !important;
      border: 0 !important;
      margin-left: 0.5em;
      padding: 0.5em 1em;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #ffffff;
      background-color: rgba(#df4545, 0.15);
      box-shadow: none !important;
      color: $--color-primary;
    }
  }
}

//全屏高的tabs  页面分页
.flexTabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__header {
    margin-bottom: 2.5vh;
  }
  .el-tabs__item.is-active {
    color: $--color-text-primary;
    font-weight: bold;
  }
  .el-tabs__nav-wrap::after {
    background: #ebecef;
  }
  .el-tabs__content {
    flex: 1;
    min-height: 10px;
    margin: 0 (-$--base-padding);
  }
  .el-tab-pane {
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    padding: 0 $--base-padding;
  }
  .panel-table {
    flex: 1;
  }
  .panel-table__table {
    flex: 1;
    min-height: 10px;
  }
  &-rtbtn {
    position: absolute;
    z-index: 99;
    right: $--base-padding + 12;
  }
}

//----------------------------
// notification
//----------------------------
.alarmNote {
  width: 380px;
  &__content {
    padding: 0.8em 0;
    display: flex;
    align-items: center;
  }
  &__icon {
    display: inline-block;
    min-width: 74px;
    width: 74px;
    height: 74px;
    margin-right: 30px;
    background: url("./assets/img/icon_alarm.png") no-repeat center;
  }
  h2 {
    font-size: 21px;
  }
  p {
    color: #a85858;
    line-height: 2;
  }
  a {
    margin-left: 1em;
    color: $--color-text-regular;
    font-size: 0.85em;
  }
}

.fixFooter {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  top: auto !important;
  z-index: 2000;
  // width: 100%;
  background: #fff;
  border-top: 1px solid $--border-color-base;
  line-height: 44px;
  text-align: center;
  font-size: $--font-size-small;
  color: $--color-text-regular;
}

.fixTime {
  position: absolute;
  z-index: 999;
  bottom: 40px;
  left: 300px;
  color: $--color-text-placeholder;
  font-size: 12px;
}
@media screen and (max-width: $--lg) {
  .fixTime {
    bottom: 30px;
  }
}
//----------------------------
//  自适应
//----------------------------
@media screen and (max-width: $--lg) {
  body {
    font-size: $--font-size-small;
  }
}
</style>
